import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router";
import AddPersonModal from "~components/AddPersonModal";
import QuickLink from "./QuickLink";

const AddPersonLink = () => {
  const [isAddPersonModalOpen, setIsAddPersonModalOpen] = useState(false);
  const { formatMessage } = useIntl();
  const { customerId, sport, organizationId } = useParams();
  const navigate = useNavigate();
  const navigateToPersonDetailsPage = (_, personId: string) =>
    navigate(`/${customerId}/admin/${sport}/${organizationId}/persons/manage/${personId}`);

  return (
    <>
      <QuickLink
        title={formatMessage({ id: "person.add.quickLink.title" })}
        description={formatMessage({ id: "person.add.quickLink.description" })}
        handleClick={() => setIsAddPersonModalOpen(true)}
      />
      <AddPersonModal open={isAddPersonModalOpen} handleClose={() => setIsAddPersonModalOpen(false)} onAdd={navigateToPersonDetailsPage} />
    </>
  );
};

export default AddPersonLink;
